// extracted by mini-css-extract-plugin
module.exports = {"gdpr":"gdpr-xsi1-","copy-container":"copy-container-emhOr","copyContainer":"copy-container-emhOr","close":"close-59-Cp"};